export default {
  getCentrosDeCusto: state => state.centrosDeCusto,
}
